var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFavouriteinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.328 1.843C7.347-2.063 0 .556 0 6.71v.714c0 1.782.618 3.509 1.75 4.886L12 24l10.25-11.691A7.696 7.696 0 0 0 24 7.423V6.71c0-6.153-7.347-8.772-11.328-4.866A6.88 6.88 0 0 0 12 2.61a6.88 6.88 0 0 0-.672-.766Zm10.16 9.819A6.697 6.697 0 0 0 23 7.423V6.71c0-5.534-7.01-7.722-10.202-3.497L12 4.268l-.798-1.056C8.01-1.013 1 1.175 1 6.709v.714c0 1.545.534 3.043 1.512 4.239L12 22.483l9.488-10.821Z",
  fill: "#252829"
})));
export default SvgFavouriteinline;